import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__